import { PerformanceAssessmentDocumentationMode } from '../enum/performance.assessment.enum';

export const getAssessmentDocumentationMode = (
  assessment:
    | {
        documentationMode?: PerformanceAssessmentDocumentationMode;
        performanceVisualId?: number | null;
      }
    | null
    | undefined,
): PerformanceAssessmentDocumentationMode =>
  assessment?.documentationMode ??
  (assessment?.performanceVisualId != null
    ? PerformanceAssessmentDocumentationMode.VISUAL
    : PerformanceAssessmentDocumentationMode.COMPETENCE_ONLY);
